import { getUnreadNotifications, getNotifications } from './selectors'

import { dataFetched, dataRemoved } from 'data/graphql'
import NotificationsAPI from 'remote/notifications'
import InvitesAPI from 'remote/invites'

export const acknowledgeNotifications = (additionalFilter = x => true) => ({
  getState,
  dispatch,
  graphQLClient,
}) => {
  const state = getState()
  const allNotifications = getUnreadNotifications(state)

  const notificationIds = allNotifications
    .filter(additionalFilter)
    .map(({ id }) => id)
    .toArray()

  // don't do anything unless there are notifications to aknowledge
  const query =
    notificationIds.length === 0
      ? null
      : graphQLClient
          .mutate({
            query: NotificationsAPI.acknowledgeNotifications,
            variables: {
              notificationIds,
            },
          })
          .then(({ data }) => {
            dispatch(dataFetched(data.acknowledgeNotifications))
          })

  return {
    type: 'AKNOWLEDGE_NOTIFICATIONS',
    payload: query,
    meta: {
      notificationIds,
    },
  }
}

export const unAcknowledgeNotifications = (additionalFilter = x => true) => ({
  getState,
  dispatch,
  graphQLClient,
}) => {
  const state = getState()
  const allNotifications = getNotifications(state)

  const notificationIds = allNotifications
    .filter(additionalFilter)
    .map(({ id }) => id)
    .toArray()

  // don't do anything unless there are notifications to unacknowledge
  const query =
    notificationIds.length === 0
      ? null
      : graphQLClient
          .mutate({
            query: NotificationsAPI.unacknowledgeNotifications,
            variables: {
              notificationIds,
            },
          })
          .then(({ data }) => {
            dispatch(dataFetched(data.unacknowledgeNotifications))
          })

  return {
    type: 'UNACKNOWLEDGE_NOTIFICATIONS',
    payload: query,
    meta: {
      notificationIds,
    },
  }
}

export function markNotificationsAsDisplayed(notificationIds) {
  return ({ getState, dispatch, graphQLClient }) => {
    return {
      type: 'MARK_NOTIFICATION_DISPLAYED',
      payload: graphQLClient
        .mutate({
          query: NotificationsAPI.markNotificationsAsDisplayed,
          variables: {
            notificationIds,
          },
        })
        .then(({ data }) => {
          dispatch(dataFetched(data.markNotificationsAsDisplayed))
        }),
    }
  }
}

export function nudge({ userId, userToInvite = null, noteId }) {
  return function({ dispatch, graphQLClient }) {
    let apiCallSequence = Promise.resolve(userId)

    if (userToInvite) {
      apiCallSequence = apiCallSequence
        .then(() => {
          return graphQLClient.mutate({
            query: InvitesAPI.createInvites,
            variables: {
              invites: [
                {
                  email: userToInvite.email,
                  isContact: true,
                },
              ],
            },
          })
        })
        .then(({ data }) => {
          dispatch(dataFetched(data.createInvites))
          dispatch(
            dataRemoved({
              __typename: 'ContactUser',
              id: userToInvite.id,
            })
          )
          return data.createInvites[0].id
        })
    }

    apiCallSequence.then(existingUserId => {
      return graphQLClient.mutate({
        query: NotificationsAPI.nudgeUser,
        variables: {
          userId: existingUserId,
          noteId,
        },
      })
    })
  }
}
